//@ 取得 URL Search Param
export default function getURLSearchParam(paramKey: string) {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramKey);
}
